/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import './shared/sentryInit';

console.log('Hello World from Webpacker');

// Simple fix for Bootstrap modals
document.addEventListener('turbolinks:load', initializeModals);
document.addEventListener('DOMContentLoaded', initializeModals);

function initializeModals() {
  // Modal triggers
  document.querySelectorAll('[data-toggle="modal"]').forEach((trigger) => {
    trigger.onclick = function (e) {
      e.preventDefault();

      const target = document.querySelector(this.getAttribute('data-target'));
      if (target) {
        showModal(target);
      }

      return false;
    };
  });

  // Close buttons
  document.querySelectorAll('[data-dismiss="modal"]').forEach((closeBtn) => {
    closeBtn.onclick = function (e) {
      e.preventDefault();

      const modal = this.closest('.modal');
      if (modal) {
        hideModal(modal);
      }

      return false;
    };
  });

  // ESC key close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const modal = document.querySelector('.modal.show');
      if (modal) {
        hideModal(modal);
      }
    }
  });

  // Click outside modal
  document.addEventListener('click', (e) => {
    if (
      e.target.classList.contains('modal') &&
      e.target.classList.contains('show')
    ) {
      hideModal(e.target);
    }
  });
}

function showModal(modal) {
  modal.style.display = 'block';
  modal.classList.add('show');
  document.body.classList.add('modal-open');

  // Add backdrop
  const backdrop = document.createElement('div');
  backdrop.classList.add('modal-backdrop', 'fade', 'show');
  document.body.appendChild(backdrop);
}

function hideModal(modal) {
  modal.style.display = 'none';
  modal.classList.remove('show');
  document.body.classList.remove('modal-open');

  // Remove backdrop
  const backdrop = document.querySelector('.modal-backdrop');
  if (backdrop) {
    backdrop.remove();
  }
}
